import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {
    factory,
    QualificationRecordResultModel,
    QualificationRecordsClient,
    ResultError, SeafarerProfileLightViewModel,
    UpdateQualificationResultModel
} from "@/api-client";
import {BModal} from "bootstrap-vue";
import TrueFalse from "@/features/shared/TrueFalseOptions";
import toasts from "@/components/Toasts";

@Component
export default class QualificationResultModalBase extends Vue {

    result: QualificationRecordResultModel = factory.create(QualificationRecordResultModel);

    @Prop({required: true})
    recordId!:string;

    @Prop()
    onSubmit!: Function;

    @Prop({default: "qualification-result-add-modal"})
    id!: string;

    validationErrors: ResultError = factory.create(ResultError);
    selectedSeafarer: SeafarerProfileLightViewModel | null = null;

    $refs!: {
        modal: BModal;
    };

    passedOptions = TrueFalse.options;

    mounted() {
        this.$refs.modal.$on("hide", () => this.reset());
    }

    async submit() {
        if(!(await this.validate())){
            return;
        }
        this.onSubmit(QualificationRecordResultModel.fromJS(this.result));
        this.close();
    }

    close(){
        this.$refs.modal.hide();
    }

    async validate(){
        this.validationErrors = factory.create(ResultError);
        try{
            const model = new UpdateQualificationResultModel();
            model.recordId = this.recordId;
            model.seafarerId = this.result.seafarer!.id;
            model.certificateNumber = this.result.certificateNumber;
            model.passed = this.result.passed;
            model.comment = this.result.comment;
            await new QualificationRecordsClient().validateQualificationResult(model);
            toasts.success(this.$ls.Global_Toast_SaveSuccess);
        }
        catch( error ) {
            for (const key in error.messages) {
                if (error.messages && error.messages[key]) {
                    const element = error.messages[key];
                    this.validationErrors.appendMessage(element[0],key);
                }
            }
            return this.validationErrors.isEmpty;
        }
        return this.validationErrors.isEmpty;
    }

    private reset() {
        this.selectedSeafarer = null;
        this.result = factory.create(QualificationRecordResultModel);
        this.validationErrors = factory.create(ResultError);
    }
}